import type { Form } from '../../../../common/types/form';
import type { Documentation } from '../../../../common/types/documentation';

import dateHoursParticipantsFields from '../../../form/dateHoursParticipantsFields';

const giveFurtherEducationForm: Form<Documentation> = {
  key: 'giveFurtherEducation',
  title: 'Fortbildungen geben',
  fields: [
    {
      key: 'topic',
      label: 'Thema',
      fieldTypes: 'text',
    },
    ...dateHoursParticipantsFields,
  ],
};

export default giveFurtherEducationForm;
